export const API_ERROR = "Oops, something went wrong";
export const CONFLICTING_SCHEDULE_ERROR =
  "Sorry! The time you are trying to book is already taken. Please pick another one.";
export const CONFLICTING_TIME_FRAME_ERROR =
  "Sorry! That time frame is already taken. Please pick another one.";
export const SERVICE_UNAVAILABLE_ERROR =
  "Service currently unavailable, please try again later.";
export const NETWORK_ERROR = "Network error, please try again later.";
export const NOT_FOUND_ERROR = "Not found, please try again later.";
export const NO_RESPONSE_ERROR = "No response, please try again later.";
export const REQUEST_TIMEOUT_ERROR = "Request timeout, please try again later.";
export const REQUEST_ERROR = "Request error, please try again later.";

const Errors = {
  API_ERROR,
  CONFLICTING_SCHEDULE_ERROR,
  CONFLICTING_TIME_FRAME_ERROR,
  SERVICE_UNAVAILABLE_ERROR,
  NETWORK_ERROR,
  NOT_FOUND_ERROR,
  NO_RESPONSE_ERROR,
  REQUEST_TIMEOUT_ERROR,
  REQUEST_ERROR,
};
export default Errors;
